import { getBackendUrl } from "utils/getBackendUrl";

export const login = async (email, password) => {
  const endpoint = getBackendUrl();
  return fetch(`${endpoint}/login`, {
    method: "POST",
    body: JSON.stringify({ email, password }),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const logout = () => {
  const endpoint = getBackendUrl();
  return fetch(`${endpoint}/logout`, {
    method: "POST",
    credentials: "include",
  });
};

export const refresh = async () => {
  const endpoint = getBackendUrl();
  return fetch(`${endpoint}/refresh`, {
    method: "POST",
    credentials: "include",
  });
};
